const TOUR_STORAGE_KEY = 'seospider_ecwid_guided_tour_done_v1';

function apiBase() {
  return import.meta.env.VITE_BACKEND_URL || '';
}

/** Persist tour completion for this site (survives new browsers). */
export async function persistGuidedTourToServer(storeId) {
  if (!storeId || typeof window === 'undefined') return;
  const base = apiBase();
  if (!base) return;
  try {
    await fetch(`${base}/api/guided-tour?id=${encodeURIComponent(storeId)}`, { method: 'POST' });
  } catch {
    // best-effort
  }
}

/** Load server flag and sync localStorage when the site already completed the tour elsewhere. */
export async function syncGuidedTourFromServer(storeId) {
  if (!storeId || typeof window === 'undefined') return hasCompletedGuidedTour();
  const base = apiBase();
  if (!base) return hasCompletedGuidedTour();
  try {
    const res = await fetch(`${base}/api/guided-tour?id=${encodeURIComponent(storeId)}`);
    if (!res.ok) return hasCompletedGuidedTour();
    const data = await res.json();
    if (data.completed === true) {
      markGuidedTourCompleted();
      return true;
    }
    return hasCompletedGuidedTour();
  } catch {
    return hasCompletedGuidedTour();
  }
}

export function hasCompletedGuidedTour() {
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(TOUR_STORAGE_KEY) === '1';
  } catch {
    return true;
  }
}

export function markGuidedTourCompleted() {
  try {
    window.localStorage.setItem(TOUR_STORAGE_KEY, '1');
  } catch {
    // ignore
  }
}
